"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
var _gradeInfo = require("@/api/basic/gradeInfo.js");
var _member_label = require("@/api/member/member_label.js");
var _popupTypes = require("@/utils/popupTypes.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CommunityHomePopupForm',
  props: {
    // 编辑ID（从路由或父组件传入）
    editId: {
      type: [Number, String],
      default: null
    },
    // 是否为编辑模式
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      formData: {
        title: '',
        sendScene: [],
        // 对应菜单页的sendScene，默认勾选外卖
        isVip: 1,
        // 对应菜单页的isVip，默认选中"全部"
        vipGrade: [],
        // 对应菜单页的vipGrade，默认选择普卡
        isAddQy: 1,
        // 对应菜单页的isAddQy，默认选中"全部"
        vipLabel: [],
        // 对应菜单页的vipLabel，会员标签
        recommendType: 1,
        // 对应菜单页的recommendType，默认选中"无"
        recommendContent: '',
        // 推荐内容
        recommendContentId: null,
        // 推荐内容ID（页面id或URL）
        recommendContentParam: null,
        // 跳转参数
        userType: 1,
        // 对应菜单页的userType，默认选中"普通"
        showImage: null,
        // 对应菜单页的showImage
        isEnable: true,
        // 对应菜单页的isEnable，默认选中"是"
        isShow: true,
        // 是否展示，默认选中"是"
        dateRange: [],
        // 时间范围
        // 分组类型相关字段
        cdpGrpType: 0,
        cdpGrpId: null
      },
      // 图片资源前缀
      imagePrefix: '',
      fileList: [],
      // 照片墙文件列表
      previewVisible: false,
      // 预览对话框显示状态
      previewImageUrl: '',
      // 预览图片URL
      // CDP分组相关数据
      cdpGroupOptions: [],
      cdpGroupLoading: false,
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }]
      },
      channelOptions: [{
        label: '菜单页',
        value: 'menu'
      }, {
        label: '首页',
        value: 'home'
      }, {
        label: '积分商城',
        value: 'pointsMall'
      }, {
        label: '充值页',
        value: 'recharge'
      }],
      contentTypeOptions: [{
        label: '单品详情',
        value: 'product'
      }, {
        label: '活动页面',
        value: 'activity'
      }, {
        label: 'H5链接',
        value: 'h5'
      }, {
        label: '其他',
        value: 'other'
      }],
      // 页面列表数据
      pageList: [],
      // 等级相关数据
      vipGrades: [],
      // 会员标签数据
      vipLabels: []
    };
  },
  watch: {
    // 监听初始数据变化
    editId: {
      handler: function handler(newId) {
        if (newId) {
          this.fetchDetailById(newId);
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // 组件挂载后获取图片前缀和等级列表
    this.getImagePrefix();
    this.getVipGradeList();
    this.getVipLabelList();
    // 获取页面列表
    this.getPageList();
  },
  methods: {
    changeRecommendInfo: function changeRecommendInfo() {
      this.formData.recommendContent = '';
      this.formData.recommendContentId = '';
      this.formData.recommendContentParam = '';
    },
    // 获取会员标签列表
    getVipLabelList: function () {
      var _getVipLabelList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _member_label.queryMemberLabelPage)({
                page: 1,
                limit: 10,
                keywords: ''
              });
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.records) {
                this.vipLabels = response.records.map(function (label) {
                  return {
                    id: label.fnId,
                    name: label.labelName
                  };
                });
                console.log('获取会员标签列表成功：', this.vipLabels);
              } else {
                this.$message.error('获取会员标签列表失败');
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取会员标签列表错误：', _t);
              this.$message.error('获取会员标签列表失败');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getVipLabelList() {
        return _getVipLabelList.apply(this, arguments);
      }
      return getVipLabelList;
    }(),
    // 通过ID获取详情
    fetchDetailById: function fetchDetailById(id) {
      var _this = this;
      (0, _popupConfig.getPopupInfo)(id).then(function (res) {
        var data = res && (res.data || res.xyPopUp || res); // 兼容不同返回包装
        if (data) {
          _this.initFormData(data);
        }
      }).catch(function (err) {
        console.error('获取详情失败:', err);
        _this.$message.error('获取详情失败');
      });
    },
    // 获取会员等级列表
    getVipGradeList: function () {
      var _getVipGradeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100 // 获取所有等级，如果等级很多可以分页
              });
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.records) {
                this.vipGrades = response.records.map(function (grade) {
                  return {
                    id: grade.id,
                    name: grade.name,
                    levelId: grade.levelId
                  };
                });
                console.log('获取等级列表成功：', this.vipGrades);
              } else {
                this.$message.error('获取等级列表失败');
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取等级列表错误：', _t2);
              this.$message.error('获取等级列表失败');
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getVipGradeList() {
        return _getVipGradeList.apply(this, arguments);
      }
      return getVipGradeList;
    }(),
    // 获取图片资源前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context3.sent;
              console.log('获取图片前缀响应：', response);
              if (response.code === 200) {
                this.imagePrefix = response.data;
                console.log('获取图片前缀成功：', this.imagePrefix);
              } else {
                console.error('获取图片前缀失败：', response.message);
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取图片前缀错误：', _t3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 初始化表单数据
    initFormData: function initFormData(data) {
      if (!data) return;

      // 映射列表数据到表单数据，保持与菜单页字段对应
      this.formData = {
        title: data.title || '',
        sendScene: data.sendScene ? data.sendScene.split(',').map(function (v) {
          return Number(v);
        }) : [3],
        // 对应菜单页的sendScene，默认勾选外卖
        isVip: data.isVip !== undefined ? Number(data.isVip) : 1,
        // 对应菜单页的isVip
        vipGrade: data.vipGrade ? data.vipGrade.split(',').map(function (v) {
          return Number(v);
        }) : [1],
        // 对应菜单页的vipGrade
        isAddQy: data.isAddQy !== undefined ? Number(data.isAddQy) : 1,
        // 对应菜单页的isAddQy
        vipLabel: data.vipLabel ? data.vipLabel.split(',') : [],
        // 对应菜单页的vipLabel
        recommendType: data.recommendType !== undefined ? Number(data.recommendType) : 1,
        // 对应菜单页的recommendType
        recommendContent: data.recommendContent || '',
        // 推荐内容
        recommendContentId: data.recommendContentId != null ? String(data.recommendContentId) : null,
        // 推荐内容ID（页面id或URL）
        recommendContentParam: data.recommendContentParam || null,
        // 跳转参数
        userType: data.userType !== undefined ? Number(data.userType) : 1,
        // 对应菜单页的userType
        showImage: data.showImage || null,
        // 对应菜单页的showImage
        isEnable: data.isEnable !== undefined ? data.isEnable : true,
        // 对应菜单页的isEnable
        isShow: data.isShow !== undefined ? data.isShow : true,
        // 是否展示
        dateRange: this.formatTimestampToRange(data.showStartTime, data.showEndTime),
        // 时间范围
        // 分组类型相关字段
        cdpGrpType: data.cdpGrpType !== undefined ? Number(data.cdpGrpType) : 0,
        cdpGrpId: data.cdpGrpId || null
      };

      // 如果有图片，初始化文件列表
      if (data.showImage) {
        this.fileList = [{
          name: '图片',
          url: data.showImage,
          uid: Date.now()
        }];
      }

      // 如果已选择分组类型，加载对应的分组列表
      if (this.formData.cdpGrpType !== 0) {
        this.queryCdpGroupList('');
      }
    },
    // 将时间戳转换为日期范围数组
    formatTimestampToRange: function formatTimestampToRange(startTime, endTime) {
      if (!startTime || !endTime) return [];

      // 将时间戳转换为Date对象
      var startDate = new Date(startTime);
      var endDate = new Date(endTime);
      return [startDate, endDate];
    },
    // 格式化日期时间为Java后端可识别的格式
    formatDateTime: function formatDateTime(date) {
      if (!date) return null;

      // 统一返回时间戳
      if (date instanceof Date) {
        return date.getTime();
      }

      // 如果是字符串，先转换为Date再取时间戳
      if (typeof date === 'string') {
        return new Date(date).getTime();
      }
      return date;
    },
    // 处理分组类型变化
    handleCdpGrpTypeChange: function handleCdpGrpTypeChange(value) {
      // 清空之前选择的分组
      this.formData.cdpGrpId = null;
      this.cdpGroupOptions = [];

      // 如果选择了分组类型，则查询对应的分组列表
      if (value !== 0) {
        this.queryCdpGroupList('');
      }
    },
    // 查询CDP分组或消费行为信息
    queryCdpGroupList: function () {
      var _queryCdpGroupList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(query) {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(this.formData.cdpGrpType === 0)) {
                _context4.next = 1;
                break;
              }
              this.cdpGroupOptions = [];
              return _context4.abrupt("return");
            case 1:
              _context4.prev = 1;
              this.cdpGroupLoading = true;
              _context4.next = 2;
              return (0, _popupConfig.queryCdpGroupList)({
                type: this.formData.cdpGrpType,
                name: query
              });
            case 2:
              response = _context4.sent;
              if (response.code === 200) {
                this.cdpGroupOptions = response.data.map(function (item) {
                  return {
                    value: item.id,
                    label: item.name
                  };
                });
              } else {
                this.$message.error('查询分组列表失败: ' + (response.message || '未知错误'));
              }
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](1);
              console.error('查询分组列表错误:', _t4);
              this.$message.error('查询分组列表失败: ' + (_t4.message || '网络错误'));
            case 4:
              _context4.prev = 4;
              this.cdpGroupLoading = false;
              return _context4.finish(4);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function queryCdpGroupList(_x) {
        return _queryCdpGroupList2.apply(this, arguments);
      }
      return queryCdpGroupList;
    }(),
    // 处理图片选择
    handleImageChange: function handleImageChange(file, fileList) {
      var _this2 = this;
      if (file.status === 'ready') {
        // 本地预览
        var reader = new FileReader();
        reader.onload = function (e) {
          file.url = e.target.result;
          _this2.fileList = [_objectSpread({}, file)];
        };
        reader.readAsDataURL(file.raw);

        // 开始上传
        (0, _popupConfig.uploadPopupImage)(file.raw).then(function (res) {
          var url = res && res.data || res;
          if (!url) {
            _this2.$message.error('上传失败');
            return;
          }
          // 设置为返回的URL
          _this2.formData.showImage = url;
          // 更新fileList中的展示URL
          _this2.fileList = [{
            name: file.name,
            url: url,
            uid: file.uid
          }];
          _this2.$message.success('图片上传成功');
        }).catch(function (err) {
          console.error('图片上传失败:', err);
          _this2.$message.error('图片上传失败');
          _this2.fileList = [];
          _this2.formData.showImage = null;
        });
      }
    },
    // 处理图片移除
    handleImageRemove: function handleImageRemove(file) {
      this.fileList = [];
      this.formData.showImage = null;
    },
    // 处理图片预览
    handleImagePreview: function handleImagePreview(file) {
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },
    // 处理超出限制
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('只能上传一张图片!');
    },
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context5.sent;
              if (response.code === 200 && response.data) {
                // 将返回的页面数据转换为下拉选项格式
                this.pageList = response.data.map(function (item) {
                  return {
                    value: item.pageUrl,
                    label: item.pageName,
                    id: String(item.id)
                  };
                });

                // 更新contentTypeOptions以使用从接口获取的页面数据
                this.contentTypeOptions = this.pageList;
                console.log('获取页面列表成功：', this.pageList);
              } else {
                console.error('获取页面列表失败：', response.message);
              }
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t5 = _context5["catch"](0);
              console.error('获取页面列表错误：', _t5);
              this.$message.error('获取页面列表失败');
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 图片上传前验证
    beforeImageUpload: function beforeImageUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }
      return false; // 阻止自动上传
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      this.$refs.communityHomeForm.validate(function (valid) {
        if (valid) {
          // 构造要提交的数据，保持与菜单页字段对应
          var submitData = {
            id: _this3.isEdit && _this3.initialData ? _this3.initialData.id : null,
            title: _this3.formData.title,
            recommendType: _this3.formData.recommendType,
            recommendContent: _this3.formData.recommendContent,
            // 推荐内容
            recommendContentId: _this3.formData.recommendContentId,
            // 推荐内容ID（页面id或URL）
            recommendContentParam: _this3.formData.recommendContentParam,
            // 跳转参数
            recommendPriority: 0,
            // 默认优先级
            popType: _popupTypes.PopupTypes.POP_TYPE.COMMUNITY,
            // 社区首页弹窗类型
            sendScene: (_this3.formData.sendScene || []).join(','),
            // 对应菜单页的sendScene
            showStartTime: _this3.formatDateTime(_this3.formData.dateRange[0]),
            // 开始时间
            showEndTime: _this3.formatDateTime(_this3.formData.dateRange[1]),
            // 结束时间
            showPlatform: '1',
            // 默认微信
            showImage: _this3.formData.showImage ? _this3.formData.showImage.name || _this3.formData.showImage : '',
            // 对应菜单页的showImage
            isEnable: _this3.formData.isEnable,
            // 对应菜单页的isEnable
            isShow: _this3.formData.isShow,
            // 是否展示
            isVip: _this3.formData.isVip,
            // 对应菜单页的isVip
            isAddQy: _this3.formData.isAddQy,
            // 对应菜单页的isAddQy
            isSaleOrder: 1,
            // 默认值，与菜单页保持一致
            isNewPeopleCoupon: 1,
            // 默认值，与菜单页保持一致
            vipGrade: (_this3.formData.vipGrade || []).join(','),
            // 对应菜单页的vipGrade
            userType: _this3.formData.userType,
            // 对应菜单页的userType
            vipLabel: (_this3.formData.vipLabel || []).join(','),
            // 对应菜单页的vipLabel
            // 分组类型相关字段
            cdpGrpType: _this3.formData.cdpGrpType,
            cdpGrpId: _this3.formData.cdpGrpId
            // 其他字段根据需要添加
          };

          // 调用API保存数据
          (0, _popupConfig.saveOrUpdatePopupConfig)(submitData).then(function (response) {
            var action = _this3.isEdit ? '编辑' : '添加';
            _this3.$message.success("".concat(action, "\u6210\u529F"));
            console.log('保存成功:', response);
            // 保存成功后触发查询刷新
            _this3.$emit('saved');
            // 保存成功后关闭标签页
            _this3.$emit('cancel');
          }).catch(function (error) {
            console.error('保存失败:', error);
            _this3.$message.error('保存失败');
          });
        } else {
          _this3.$message.error('请完善表单信息');
          return false;
        }
      });
    },
    // 取消操作
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};